import _ from 'lodash'
import { AnyAction } from 'redux'
import { ModalType } from 'store/actions/modals'
import { ModalAction } from 'store/types'

export type Modal = {
  modalType: ModalType
  modalProps: unknown
}

export const initialState: { openModals: Modal[] } = {
  openModals: []
}

const modals = (state = initialState, action: AnyAction): { openModals: Modal[] } => {
  switch (action.type) {
    case ModalAction.SHOW_MODAL: {
      const payload: Modal = { modalType: action.modalType, modalProps: action.modalProps }
      const filteredModals = state.openModals.filter(({ modalType }) => modalType !== action.modalType)
      const updatedModals = [...filteredModals, payload]

      return {
        ...state,
        openModals: [...updatedModals]
      }
    }
    case ModalAction.UPDATE_MODAL: {
      const newOpenModals = state.openModals.map(modal => {
        if (modal.modalType === action.modalType) {
          return {
            ...modal,
            modalProps: action.modalProps
          }
        }
        return modal
      })

      return {
        ...state,
        openModals: newOpenModals
      }
    }
    case ModalAction.HIDE_MODAL: {
      const [, ...rest] = state.openModals.reverse()
      return {
        ...state,
        openModals: rest
      }
    }
    default:
      return state
  }
}

export default modals
